/* 提供给原生退出登录界面 */
<template>
  <div :class="$style.logout">
    <div :class="$style.content">
      <header>
        <span>切换账号</span>
        <img
          :src="`${$cdnLink}/wanXin/orangeTheme/fanhui.png`"
          alt
          :class="$style.fanhui"
          @click="cancel"
        />
      </header>
      <main>
        <p>确定要切换账号吗?</p>
        <div :class="$style.btnGroup">
          <button :class="$style.cancel" @click="cancel">继续游戏</button>
          <button :class="$style.backLogin" @click="backLogin">切换账号</button>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { registQuitGameFunction } from '@/bridge/AppJsBridge'
import { isPure } from '@/libs/utils';

export default {
  name: '',
  data() {
    return {
    };
  },
  methods: {
    cancel() {
      this.$emit('close');
    },
    backLogin() {
      if (isPure()) {
        registQuitGameFunction(null)
      } else {
        location.reload();
      }
    }
  }
}
</script>

<style lang="scss" module>
@import "../../../assets/css/common";
.logout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.55);
  box-sizing: border-box;
  .content {
    @include full-screen-window();
    > header {
      position: relative;
      > span {
        font-weight: 600;
        font-style: italic;
      }
      .fanhui {
        position: absolute;
        top: 17px;
        right: 17px;
        width: 17px;
        height: 12px;
      }
    }
    > main {
      > p {
        text-align: center;
        font-size: 16px;
        padding-top: 70px;
        color: #FF7955;
      }
      .btnGroup {
        width: 100%;
        position: absolute;
        bottom: 10px;
        display: flex;
        justify-content: center;
        > button {
          border: none;
          outline: none;
          background-color: transparent;
          width: 125px;
          height: 35px;
          color: #ffffff;
          border-radius: 35px;
          margin: 0 10px;
          background-size: cover;
          font-size: 14px;
        }
        .cancel {
          background-color: #b1aba8;
        }
        .backLogin {
          background: linear-gradient(90deg, #ff3b36, #ff7955);
        }
      }
    }
  }
}
</style>